/**
 * UI-related constants
 */

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
} as const;

export const ANIMATION_DURATION = {
  FAST: 150,
  DEFAULT: 300,
  SLOW: 500,
} as const;

export const Z_INDEX = {
  DROPDOWN: 1000,
  STICKY: 1020,
  MEGA_MENU: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  TOAST: 1080,
} as const;

export const GRID_SIZES = {
  PRODUCT_GRID: {
    COLS_SM: 1,
    COLS_MD: 2,
    COLS_LG: 3,
    COLS_XL: 4,
  },
  IMAGE_GRID: {
    COLS_SM: 2,
    COLS_MD: 3,
    COLS_LG: 4,
  },
} as const;

export const DISPLAY_INCREMENT = 12;
export const INITIAL_LOAD_COUNT = 24;

// Icon sizes (Tailwind classes)
export const ICON_SIZES = {
  XS: 'w-3 h-3',
  SM: 'w-4 h-4', 
  BASE: 'w-5 h-5',
  LG: 'w-6 h-6',
  XL: 'w-8 h-8',
} as const;

// Common spacing values
export const SPACING = {
  CARD_GAP: 2.5, // rem units
  THUMBNAIL_SIZE: {
    SMALL: 32,
    MEDIUM: 128, // w-32 h-32
    LARGE: 320,
  },
  MAX_HEIGHT_SCROLL: 32, // max-h-32
} as const;

// Modal and dialog dimensions
export const MODAL_SIZES = {
  DEFAULT: 'max-w-md',
  LARGE: 'max-w-4xl',
  FULL_HEIGHT: 'max-h-[90vh]',
} as const;

// Image aspect ratios and sizes
export const IMAGE_SIZES = {
  HERO_LOGO: {
    MOBILE: 'w-64',
    DESKTOP: 'w-80',
  },
  PRODUCT_THUMBNAIL: {
    SMALL: 'w-28 h-28',
    MEDIUM: 'w-32 h-32', 
  },
  GALLERY_HEIGHT: 'h-48',
} as const;

// Responsive breakpoint helpers
export const RESPONSIVE_SIZES = {
  IMAGE_SIZES: {
    MOBILE: "(max-width: 400px) 100vw, 300px",
    DESKTOP: "(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw",
    BRAND_NARRATIVE: "(min-width: 1024px) 20rem, (min-width: 768px) 25vw, 100vw",
  },
} as const;

// Form input dimensions
export const INPUT_SIZES = {
  MIN_HEIGHT: 44, // pixels - accessibility standard
  BUTTON_HEIGHT: 6, // h-6
  BUTTON_PADDING: 2, // px-2
} as const;

// Progress bar dimensions
export const PROGRESS_BAR = {
  HEIGHT: 2, // h-2
} as const;